import { API_BASE_URL } from '@/environment'
import { Api, adminAPI } from '@attensi/v3-client-wip'
import { customFetch } from './apiV3Utils'

export const apiV3 = new Api({
  baseUrl: API_BASE_URL,
  customFetch,
})

export const apiV3Admin = new adminAPI.Api({
  baseUrl: API_BASE_URL,
  customFetch,
})
